import { Component, OnDestroy } from '@angular/core';
import { SettingsService } from '../../settings.service';
import { SettingsBreadCrumbService, BreadCrumbOptions } from '../../settings-breadcrumb.service';
import { IdentityOrganisationApiClient } from 'src/app/services/api-clients/identity-organisation.api-client';
import { IdsForSettingsService } from '../../ids-for-settings.service';
import { Subscription } from 'rxjs';
import { OrganisationApiClient } from 'src/app/services/organisation.apiclient';
import { Plugin } from 'src/app/models/plugin';
import { OrganisationPlugins } from 'src/app/constants/settings.enum';
import { ExistsIn, SingleOrDefault } from 'src/app/_helpers/ArrayExtensionMethodHelper.functions';

@Component({
  templateUrl: './platformapi.page.html',
  styleUrls: ['./platformapi.page.css']
})
export class PlatformApiPage implements OnDestroy {
  organisationIdSubscription: Subscription;
  selectedOrganisationId: string = "";
  organisation!: any;
  useAFAS: boolean = false;
  useVisionplanner: boolean = false;
  showPlatformAPIPlugins: OrganisationPlugins[] = [OrganisationPlugins.AFAS, OrganisationPlugins.Visionplanner];
  enabledPlatformApiPlugins: Plugin[] = [];

  constructor(private organisationApiClient: OrganisationApiClient, private settingsService: SettingsService,
    private settingsBreadCrumbService: SettingsBreadCrumbService, private idsForSettingsService: IdsForSettingsService, private identityOrganisationApiClient: IdentityOrganisationApiClient) {
      this.organisationIdSubscription = this.idsForSettingsService.selectedOrganisationId$.subscribe(organisationId => {
        if (organisationId === this.selectedOrganisationId) return;
        this.selectedOrganisationId = organisationId;
        // setup specialised breadcrumb
        this.settingsBreadCrumbService.SetOrganisationBasedCrumbs(BreadCrumbOptions.Integrations(this.selectedOrganisationId), BreadCrumbOptions.Integrations_Platform(this.selectedOrganisationId));

        this.getPlatformAPIPlugins();
      });
  }

  ngOnDestroy(): void {
    if (this.organisationIdSubscription) {
      this.organisationIdSubscription.unsubscribe();
    }
  }

  getPlatformAPIPlugins() {
    this.enabledPlatformApiPlugins = [];
    this.organisationApiClient.getEnabledPlugins(this.selectedOrganisationId).subscribe((enabledPluginsData: Plugin[]) => {
      this.showPlatformAPIPlugins.forEach((plugin: OrganisationPlugins) => {
        let pluginToUse = SingleOrDefault(enabledPluginsData, "code", plugin);
        if(pluginToUse){
          pluginToUse.enabled = true;
        } else {
          pluginToUse = {code: plugin, name: plugin, enabled: false};
        }
        this.enabledPlatformApiPlugins.push(pluginToUse)
      })
    });
  }

  updateSettings(event: any) {
    this.settingsService.updateSettings(event, this.selectedOrganisationId);
  }

  updatePlugins(event: any) {
    this.settingsService.updatePlugins(event, this.selectedOrganisationId);
  }
}
